import React from "react";
import { Utils } from "../../../common/views/Utils";
import { PrintInvoiceLabelModel } from "../../models/InvoiceModel";

interface InvoiceLabelHeaderProps {
    sender: string;
    invoice: PrintInvoiceLabelModel;
}

export default function InvoiceLabelHeaderView({ sender, invoice }: InvoiceLabelHeaderProps) {
    const col12Class = "grid-col label2-col12";
    const col1Class = "grid-col label2-header-col1";
    const col2Class = "grid-col label2-header-col2";

    const phone = invoice.phone;
    const countryCode = phone.countryCode.replace("855", "0");
    const phoneNo = Utils.formatPhone(countryCode + phone.phoneNo);

    return <div className="label2-header-height">
        <div className={col12Class}>
            <div className="pt-5">
                <div className={col1Class + " "}>អ្នកផ្ញើរ</div>
                <div className={col2Class + " label2-large-font"}>{sender}</div>
            </div>

            <div className="pt-5">
                <div className={col1Class + " pt-5"}>អ្នកទទួល</div>
                <div className={col2Class + " label2-large-font"}>{phoneNo}</div>
            </div>
        </div>

        <div className={"grid-col label2-brand"}>Bees</div>
    </div>;
}